import { useMemo } from 'react';
import { BuildingPackageReadModel } from '@client/api';

export function useBuildingPackages(packages: BuildingPackageReadModel[] | undefined) {
  return useMemo(() => {
    const activePackages = packages?.filter((p) => p.isActive) ?? [];

    const hasManagement = activePackages.some((p) => p.packageType === 'Management');
    const hasPortfolio = activePackages.some((p) => p.packageType === 'Portfolio');
    // Minimum-tier semantics (Standard or higher), matching the backend's GetPackageFilteredBuildingIds.
    const hasPortfolioStandard = activePackages.some(
      (p) => p.packageType === 'Portfolio' && (p.tier === 'Standard' || p.tier === 'Premium'),
    );
    const hasEos = activePackages.some((p) => p.packageType === 'Eos');

    const isPortfolioOnly = hasPortfolio && !hasManagement;

    return {
      hasManagement,
      hasPortfolio,
      hasPortfolioStandard,
      hasEos,
      isPortfolioOnly,
      activePackages,
    };
  }, [packages]);
}
